import React, {useState, useEffect, useContext} from "react";

import './ProcedimientosProgramadosSubtabla.css';
import RRProcedimientosProgramados from "../renderRows/RRProcedimientosProgramados";
import { estructuraProcedimientoProgramado } from "../../utils/estructuras";
import procedimientoContext from "../../context/procedimientoContext/procedimientoContext";

const ProcedimientosProgramadosSubtabla = ({procsProgramados, handleChangeActivo, modo, tablaSeleccionada, componentePadre}) => {

    const [options,setOptions] = useState({procedimientos:[]});

    const pContext = useContext(procedimientoContext);
    const {procedimientoList} = pContext;

    useEffect(()=>{
    if(procedimientoList != undefined && procedimientoList != null && procedimientoList.length > 0){
        let optionsP = procedimientoList.map((p) => {return {value:p.codProc,label:p.name,id:p._id}})
        setOptions({...options,procedimientos:optionsP});
    }else setOptions({...options,procedimientos:[]});
    },[procedimientoList])

    const handleChange = (e,i,prop='',value='') => {
        let newProcs = procsProgramados.slice();
        
        if(prop != '' && value != ''){
            newProcs[i][prop] = value;
        }else{
            let {name,value} = e.target;
            (name=='NroForOT' && newProcs[i]['NroForOT'] == '') && newProcs.push({...estructuraProcedimientoProgramado});
            newProcs[i][name] = value;
        }
        handleChangeActivo({},'procsProgramados',newProcs);
    }

    const handleDelete = (p,i) => {
        if(p.NroForOT != '' || p.CodForOT != '' || p.codProc.value != ''){
            let newProcs = procsProgramados.slice();
            newProcs = newProcs.filter((p,index) => index != i);
            console.log('PreHandleChangeActivo');
            handleChangeActivo({},'procsProgramados',newProcs);
        }
    }

    return <div className={`${(tablaSeleccionada != 'procedimientosProgramados') && 'inactive'} procProgramadosSubtablaDiv`}>
        <label>Procedimientos Programados</label>
        <label id="codProcLabel">Código Procedimiento</label>
        <div className={`subtablaHeader`}>
            <label id="">Unidad Medida</label>
            <label id="">Valor Ult. Completado</label>
            <label id="">Valor Venc. Lectura</label>
            <label id="">Valor Alerta Lectura</label>
            <label id="">Valor Ult. Lectura</label>
            <label id="">Fecha Vencimiento</label>
            <label id="">Tipo Alerta</label>
            <label id="">Código ODT</label>
            <label id="">Número ODT</label>
            <label id="">Fecha Completado</label>
            <label id="">Estado</label>
        </div>
        <div className="bodyTable">
            {procsProgramados.map((p,i) => <RRProcedimientosProgramados procedimiento={p} key={i} index={i} handleChange={handleChange} procedimientoList={procedimientoList} handleDelete={handleDelete} modo={modo} optionsProcedimientos={options.procedimientos}/>)}
        </div>
    </div>

}

export default React.memo(ProcedimientosProgramadosSubtabla);